import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface CreatePromptButtonProps {
  activeTab: string;
}

export default function CreatePromptButton({
  activeTab,
}: CreatePromptButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (activeTab === "prompts") {
      navigate("/prompt-engine/create");
    } else if (activeTab === "transcripts") {
      navigate("/prompt-engine/transcript/create");
    }
  };

  return (
    <Button
      variant="primaryOutline"
      onClick={handleClick}
    >
      <Plus className="mr-2 h-4 w-4" />
      {activeTab === "prompts" ? "Create Prompt" : "Add Transcript"}
    </Button>
  );
}
